/*
  Shared react-select styles (IMP-038), matching TextField.
  Values are CSS variables from styles/tokens.css.
*/
const selectStyles = {
    control: (base) => ({
        ...base,
        backgroundColor: 'var(--color-surface)',
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        minHeight: '46px', // + 2px container border on each side = 50px, same as TextField
        padding: '0 8px',
        color: 'var(--color-text)',
        fontFamily: 'inherit',
    }),
    placeholder: (base) => ({
        ...base,
        color: 'var(--color-placeholder)',
        fontSize: 'var(--text-md)',
    }),
    singleValue: (base) => ({
        ...base,
        color: 'var(--color-text)',
        fontSize: 'var(--text-md)',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: 'var(--color-placeholder)',
    }),
    indicatorSeparator: () => ({
        display: 'none', // remove the little vertical line between text and arrow
    }),
    menu: (base) => ({
        ...base,
        borderRadius: 0,
        marginTop: 0,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? 'var(--color-surface-hover)' : 'var(--color-white)',
        color: 'var(--color-text)',
        borderRadius: 0,
        padding: '10px 12px',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: 'var(--color-selected)',
        borderRadius: 'var(--radius-xs)',
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: 'var(--color-text)',
        fontSize: 'var(--text-sm)',
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999 // make sure it's above other elements
    }),
};

export default selectStyles;
